export default __webpack_public_path__ + "static/media/elevate-lav-1.dbd72f80.png";